import {
    _getStartStyle,
    _getElStyle,
    _showClearIcon,
    _getInputElStyle,
    _getMaxLengthAttr,
    _getDisabledAttr,
    _getDisabledClass,
    _getErrorElStyle,
    _removeValidationInfo,
    _hideClearIcon
} from "./Common_Fun";
import {AssertUtils} from "goingutils";

let goColorSelCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else {
            return this.getEditorHtml(item, targetObj);
        }
    },
    /**
     * 获取但条件查询下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (
        {label, id, required, defVal = ""},
        targetObj
    ) {
        return ` <input class="search-ipt pull-left" type="text" id="${
            targetObj.prefixCls
            }_${id}">`;
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (
        {
            label,
            id,
            required,
            defVal = "",
            maxlength = 0,
            readOnly,
            disabled
        },
        targetObj
    ) {
        return `<div class="row  go-form-row flex-div">
                <div class="go-label" style="${_getElStyle(
            targetObj
        )}"><span class="start-require" ${_getStartStyle(
            {required},
            targetObj
        )}>*</span>${label}：</div> 
                <div class="go-content" style="position: relative;">
                     <input style="${_getInputElStyle(
            targetObj
        )}" :label="label"  ${_getMaxLengthAttr(
            maxlength
        )} value="${defVal}" id="${
            targetObj.prefixCls
            }_${id}" type="text"  ${_getDisabledAttr(
            readOnly,
            disabled
        )} class="go-color-sel form-control padding-l-bs  ${_getDisabledClass(
            readOnly,
            disabled
        )}">
                     <i style="${_getErrorElStyle(
            targetObj
        )}" onclick="_clearInputVal(this,['${
            targetObj.prefixCls
            }_${id}'])" class="ivu-icon ivu-icon-ios-close-circle"></i>
                     <i onmouseover="_showErrorToolTip(this,'${id}')" onmouseleave="_hideErrorToolTip(this,'${id}')" style="${_getErrorElStyle(
            targetObj
        )}"
                      class="fas fa-exclamation-triangle error-info"></i>
                </div></div>`;
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        //如果不为空的情况下才返回查询的值
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        if (AssertUtils.isNotEmpty($("#" + inputElId).val())) {
            backJson[item["id"]] = $("#" + inputElId).val();
        }
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        //时间
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        backJson[item["id"]] = $("#" + inputElId).val();
    },
    setValue(prop, propValue, item, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val(propValue);
        if (AssertUtils.isNotEmpty(propValue)) {
            _showClearIcon(inputElId);
        }
    },
    getRealValue(value) {
        return value || " ";
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        //普通输入框的输入事件
        $(parentObj)
            .find(".go-color-sel")
            .on("input", function () {
                let val = $(this).val();
                if ((val + "").length > 0) {
                    _removeValidationInfo($(this).attr("id"));
                    _showClearIcon($(this).attr("id"));
                } else {
                    _hideClearIcon($(this).attr("id"));
                }
            });

        // $(parentObj).find(".go-color-sel").minicolors({});

        //普通输入框的change事件
        $(parentObj)
            .find(".go-color-sel")
            .on("change", function () {
                let elId = $(this).attr("id");
                elId = (elId + "").replace(targetObj.prefixCls + "_", "");
                if (vueObj != null) {
                    vueObj.$emit("change", {
                        value: $(this).val(),
                        id: elId,
                        elObj: $(this)
                    });
                }
            });
    }
};

export default goColorSelCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-color-sel-ctl.js